export enum PlayerResolution {
    AUTO = 'auto',
    ULTRA_HD = 'ultra_hd',
    FULL_HD = 'full_hd',
    WUXGA = 'wuxga',
    HD_PLUS = 'hd_plus',
    HD_WIDE = 'hd_wide',
    WXGA = 'wxga',
    HD = 'hd',
}

const PlayerResolutionLabels: Record<PlayerResolution, string> = {
    [PlayerResolution.AUTO]: 'Auto',
    [PlayerResolution.ULTRA_HD]: 'Ultra HD (2560x1440)',
    [PlayerResolution.FULL_HD]: 'Full HD (1920x1080)',
    [PlayerResolution.WUXGA]: 'WUXGA (1680x1050)',
    [PlayerResolution.HD_PLUS]: 'HD+ (1440x900)',
    [PlayerResolution.HD_WIDE]: 'HD Wide (1600x900)',
    [PlayerResolution.WXGA]: 'WXGA (1366x768)',
    [PlayerResolution.HD]: 'HD (1280x720)',
}

const PlayerResolutionDimensions: Record<
    PlayerResolution,
    { width: number; height: number } | null
> = {
    [PlayerResolution.AUTO]: { width: 0, height: 0 },
    [PlayerResolution.ULTRA_HD]: { width: 2560, height: 1440 },
    [PlayerResolution.FULL_HD]: { width: 1920, height: 1080 },
    [PlayerResolution.WUXGA]: { width: 1680, height: 1050 },
    [PlayerResolution.HD_PLUS]: { width: 1440, height: 900 },
    [PlayerResolution.HD_WIDE]: { width: 1600, height: 900 },
    [PlayerResolution.WXGA]: { width: 1366, height: 768 },
    [PlayerResolution.HD]: { width: 1280, height: 720 },
}

export const playerResolutionLabel = (resolution: PlayerResolution): string => {
    const label = PlayerResolutionLabels[resolution]

    if (!label) {
        throw new Error(`Unknown player resolution: ${resolution}`)
    }

    return label
}

export const playerResolutionDimensions = (
    resolution: PlayerResolution
): { width: number; height: number } => {
    const dimension = PlayerResolutionDimensions[resolution]

    if (!dimension) {
        throw new Error(`Unknown player resolution: ${resolution}`)
    }

    return dimension
}
